import { useParams } from 'react-router-dom';
import HeaderComponent from '../header/Header';
import FooterComponent from '../footer/Footer';
import MainComponent from '../MainComponent';

const ParamWrapper = (Component) => {

    const { type } = useParams();

    const pagebr = (type === "" || type === undefined ) ? "nuevafinca" : (type === "finca" ? "nuevaunidadfinca" : "nuevaunidadindustria");

    const props = {page: pagebr};

    return (
        <>
            <HeaderComponent {...props}/>
                <MainComponent>
                    <Component {...props}/>
                </MainComponent>
            <FooterComponent />
        </>
    );
}

export default ParamWrapper;